import React from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames/bind'

import PlusMinusField from 'js/components/shared/FormElements/PlusMinusControl';

import styles from './RoomField.module.scss'

const cx = classnames.bind(styles)

const RoomField = ({
  name,
  value,
  label,
  description,
  onChange,
  minValue,
  maxValue,
}) => (
  <div className={cx('room-field')}>
    <div>
      <div className={cx('label')}>
        {label}
      </div>
      {description && (
        <div className={cx('description')}>
          {description}
        </div>
      )}
    </div>
    <PlusMinusField
      className="room-field-panel__right"
      name={name}
      onChange={onChange}
      value={value}
      minValue={minValue}
      maxValue={maxValue}
      initialValue={value}
    />
  </div>
)

RoomField.defaultProps = {
  value: 0,
}

RoomField.propTypes = {
  name: PropTypes.string.isRequired,
  value: PropTypes.number,
  minValue: PropTypes.number.isRequired,
  maxValue: PropTypes.number.isRequired,
  label: PropTypes.string.isRequired,
  description: PropTypes.string,
  onChange: PropTypes.func.isRequired,
}

export default RoomField
